export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.25-1030.03',
  commitId: '9ca1a6f6e1a80fc10f4ddafaa7a23ebc1c47a5c7',
  commitTime: '2026-03-25T10:30:03.000Z',
});
